import {Referral} from 'referral';

import {ModalState} from '../../modal/state';
import { RelayPaginationState } from '../../pagination';
import { ReferralFilterState } from 'providerapp/filter/state';


export type ProviderAppState = {
    modal: ModalState;
    referral: Referral | null;
    pagination: RelayPaginationState;
    filter: ReferralFilterState;
    offerConversationOnly: boolean;
};

export const initialState: ProviderAppState = {
    modal: {
        show: false,
        title: 'Details',
    },
    referral: null,
    pagination: new RelayPaginationState(),
    filter: {
        counties: [],
        scopeOfServices: [],
        serviceTypes: [],
        cities: [],
        zipcodes: [],
        serviceLocationTypes: [],
    },
    offerConversationOnly: false,
};
